import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCustomGeoZonesCategories(companyId, query) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].getCustomGeoZonesCategories,
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

function getCustomGeoZonesCategory(companyId, customGeoZonesCategoryId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].getCustomGeoZonesCategory,
		{
			urlParams: {
				companyId,
				customGeoZonesCategoryId,
			},
		}
	)
}

function createCustomGeoZonesCategory(companyId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].createCustomGeoZonesCategory,
		{
			urlParams: {
				companyId,
			},
			...data,
		}
	)
}


function putCustomGeoZonesCategory(companyId, customGeoZonesCategoryId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].putCustomGeoZonesCategory,
		{
			urlParams: {
				companyId,
				customGeoZonesCategoryId,
			},
			...data,
		}
	)
}


function patchCustomGeoZonesCategory(companyId, customGeoZonesCategoryId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].patchCustomGeoZonesCategory,
		{
			urlParams: {
				companyId,
				customGeoZonesCategoryId,
			},
			...data,
		}
	)
}

function deleteCustomGeoZonesCategory(companyId, customGeoZonesCategoryId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].deleteCustomGeoZonesCategory,
		{
			urlParams: {
				companyId,
				customGeoZonesCategoryId,
			},
		}
	)
}

export default {
	getCustomGeoZonesCategories,
	getCustomGeoZonesCategory,
	createCustomGeoZonesCategory,
	putCustomGeoZonesCategory,
	patchCustomGeoZonesCategory,
	deleteCustomGeoZonesCategory,
}

